// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
  {
    id: 1,
    title: "Tubo Localhost Tunnel",
    category: "Vue - JavaScript - Cloudflare",
    // img: require("@/assets/images/web-project-2.jpg"),
    img: require("@/assets/images/web-project-1.svg"),
    link: "https://www.tubo.run/",
  },
  {
    id: 2,
    title: "Coach Finder",
    // category: "Mobile Application",
    category: "Vue - Tailwind CSS - Firebase",
    // img: require("@/assets/images/mobile-project-2.jpg"),
    img: require("@/assets/images/web-project-2.svg"),
    link: "https://github.com/RomanGarza/Coach-Finder",
  },
  {
    id: 3,
    title: "Web Map",
    // category: "UI/UX Design",
    category: "JavaScript - Mapbox GL JS",
    // img: require("@/assets/images/ui-project-1.jpg"),
    img: require("@/assets/images/web-project-3.svg"),
    link: "https://github.com/RomanGarza/Rover-Maps",
  },
  {
    id: 4,
    title: "Code Editor",
    // category: "UI/UX Design",
    category: "React - JavaScript - CSS ",
    // img: require("@/assets/images/ui-project-2.jpg"),
    img: require("@/assets/images/web-project-4.svg"),
    link: "https://github.com/RomanGarza/V6-Editor",
  },
  {
    id: 5,
    title: "Budget Tracker App",
    // category: "Mobile Application",
    category: "React - JavaScript - Boostrap",
    // img: require("@/assets/images/mobile-project-1.jpg"),
    img: require("@/assets/images/web-project-5.svg"),
    link: "https://github.com/RomanGarza/Budget-Tracker",
  },
  {
    id: 6,
    title: "Quote Generator",
    category: "Javascript - Jquery - Bootstrap",
    img: require("@/assets/images/web-project-6.svg"),
    link: "https://github.com/RomanGarza/Random-Quotes",
  },
  {
    id: 7,
    title: "SpaceX Launches",
    // category: "Quality Assurance Automation",
    category: "Vue - TypeScript - Tailwind CSS",
    img: require("@/assets/images/web-project-7.svg"),
    link: "https://github.com/RomanGarza/SpaceX-Missions",
  },
  {
    id: 8,
    title: "Chat App",
    category: "React - Chat Engine - Firebase",
    img: require("@/assets/images/web-project-8.svg"),
    link: "https://github.com/RomanGarza/mundo.chat",
  },
];

export default projects;
